import { GetBlendersType, GetTubeShieldsType } from "../../../models/_publicCall";
import { GetMarketingType, GetOperationType } from "../../../models/_tickets";
import Moment from 'moment';

export const SiteVisitationPreview = (props: {
  logJob: any,
  travelTimer: () => string,
  workTimer: () => string
  tubeShieldsDB: GetTubeShieldsType[];
  blendersDB: GetBlendersType[];
  flavors: any;
}) => {
  const { logJob, travelTimer, workTimer, blendersDB, tubeShieldsDB, flavors } = props
  return (
    <div className="card mx-auto" style={{ maxWidth: '700px' }}>
      <div className="card-body">
        <div className=" ">
          <div className="">
            <div className="mt-4">
              <div className="d-flex  gap-2">
                <label
                  htmlFor="locationId"
                  className="wo-label fs-4 mb-0 fw-semibold"
                >
                  Location Name:
                </label>
                <span className="mb-0 fs-5 fw-bold">
                  {logJob?.location?.name}
                </span>
              </div>

              <div className="d-flex  gap-2 mt-2">
                <label
                  htmlFor="address"
                  className="wo-label fs-4 mb-0 fw-semibold"
                >
                  Address:
                </label>
                <span className="mb-0 fs-5 fw-bold">
                  {logJob?.location?.address}
                </span>
              </div>
              <div className="d-flex  gap-2 mt-2">
                <label
                  htmlFor="address"
                  className="wo-label fs-4 mb-0 fw-semibold"
                >
                  Contact Name:
                </label>
                <span className="mb-0 fs-5 fw-bold">
                  {logJob?.location?.contactName || '-'}
                </span>
              </div>
              <div className="d-flex  gap-2 mt-2">
                <label
                  htmlFor="address"
                  className="wo-label fs-4 mb-0 fw-semibold"
                >
                  Contact Phone:
                </label>
                <span className="mb-0 fs-5 fw-bold">
                  {logJob?.location?.contactPhone || '-'}
                </span>
              </div>
              <div className="d-flex  gap-2 mt-2">
                <label
                  htmlFor="address"
                  className="wo-label fs-4 mb-0 fw-semibold"
                >
                  Contact Email:
                </label>
                <span className="mb-0 fs-5 fw-bold">
                  {logJob?.location?.contactEmail || '-'}
                </span>
              </div>
              <div className="d-flex  gap-2 mt-2">
                <label
                  htmlFor="address"
                  className="wo-label fs-4 mb-0 fw-semibold"
                >
                  Distributor Name:
                </label>
                <span className="mb-0 fs-5 fw-bold">
                  {logJob?.location?.distributorName || '-'}
                </span>
              </div>

              <hr style={{ width: '100%' }} />

              <div className="d-flex  gap-2 mt-2">
                <label className="wo-label fs-4 mb-0 fw-semibold">
                  Travel Time: <span className="mb-0 fs-5 fw-bold">{travelTimer()}</span>
                </label>
              </div>
              <div className="d-flex  gap-2 mt-2">
                <label className="wo-label fs-4 mb-0 fw-semibold">
                  Work Time: <span className="mb-0 fs-5 fw-bold">{workTimer()}</span>
                </label>
              </div>

              <hr style={{ width: '100%' }} />

              <div className="  gap-2 mt-2">
                {
                  logJob?.job?.machinesChecks && logJob?.job?.machinesChecks.length > 0 ? (
                    logJob?.job?.machinesChecks.map(({ machine, checksDetail }: { machine: any, checksDetail: any }, index: number) => {
                      return (
                        <div key={index} className=" border-dotted border-2 border-gray-200 p-8 gap-2 mt-2">
                          <div className="">
                            <label className="wo-label mb-2 fw-semibold">
                              Machine Name: <span className="mb-0 fs-5 fw-bold">{machine?.name}</span>
                            </label>
                            <label className="wo-label mb-2 fw-semibold">
                              Serial Number: <span className="mb-0 fs-5 fw-bold">{machine?.serialNumber}</span>
                            </label>
                          </div>
                          {[
                            { label: "Machine has Polyfuses", name: "hasPolyfuses" },
                            { label: "Made 4 smoothies", name: "made4Smoothies" },
                            {
                              label:
                                "Machine Surface, Blender Bell Wiper, Bottom Wiper are clean",
                              name: "cleanlinessCheck",
                            },
                            {
                              label: "Machine Passed Getstatus",
                              name: "getStatusPassed",
                            },
                            { label: "Flowmeter Activated", name: "flowmeterActivated" },
                            {
                              label: "Water level is calibrated with scale",
                              name: "waterLevelCalibratedWithScale",
                            },
                            {
                              label: "Replace filter",
                              name: "replaceFilter",
                            },
                            {
                              label: "Replace Machine",
                              name: "replaceMachine",
                            },
                          ].map((item, idx) => (
                            <div
                              key={idx}
                              className="d-flex justify-content-between align-items-center mb-2"
                            >
                              <label className="wo-label fw-semibold">
                                {item.label}:
                              </label>
                              <div className="form-check form-switch form-check-custom">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={checksDetail[item.name]}
                                  name={item.name}
                                  disabled={true}
                                />
                              </div>
                            </div>
                          ))}

                          <div>
                            {checksDetail?.replaceMachine && (
                              <>
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <label className="wo-label fw-semibold">
                                    New Machine serial number: <span className="mb-0 fs-5 fw-bold">
                                      {checksDetail?.newMachineSerialNumber}
                                    </span>
                                  </label>

                                </div>

                                {
                                  checksDetail?.oldMachineShiftToLocationId && (
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                      <label className="wo-label fw-semibold">
                                        Old machine shift to: <span className="mb-0 fs-5 fw-bold">
                                          {checksDetail?.oldMachineShiftToLocationName}
                                        </span>
                                      </label>

                                    </div>)}
                              </>
                            )}
                          </div>
                          <div>
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <label className="wo-label fw-semibold">
                                Sanitizer Level: <span className="mb-0 fs-5 fw-bold">
                                  {checksDetail?.sanitizerLevel}
                                </span>
                              </label>

                            </div>
                            {
                              checksDetail?.blenderId && (
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <label className="wo-label fw-semibold">
                                    Blender: <span className="mb-0 fs-5 fw-bold">
                                      {blendersDB?.find((blender) => blender.id === checksDetail?.blenderId)?.title}
                                    </span>
                                  </label>

                                </div>

                              )
                            }

                            {
                              checksDetail?.tubeDoorId && (
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                  <label className="wo-label fw-semibold">
                                    Tube Door Shield: <span className="mb-0 fs-5 fw-bold">
                                      {tubeShieldsDB?.find((tubeShield) => tubeShield.id === checksDetail?.tubeDoorId)?.name}
                                    </span>
                                  </label>
                                </div>
                              )
                            }

                          </div>

                          <div>
                            {logJob?.job?.tickets.length > 0 && (
                              logJob.job.tickets.filter((ticket: any) => ticket.machineId === machine.id).map((ticket: any, index: number) => {
                                return (
                                  <div key={ticket.id} className="justify-content-between align-items-center mb-2">
                                    <label className="wo-label fw-semibold">
                                      Ticket ID: <span className="mb-0 fs-5 fw-bold">
                                        {ticket.uuid}
                                      </span>
                                    </label>
                                    <label className="wo-label fw-semibold">
                                      Ticket Status: <span className="mb-0 fs-5 fw-bold">
                                        {ticket.status}
                                      </span>
                                    </label>
                                    <label className="wo-label fw-semibold">
                                      Ticket Type: <span className="mb-0 fs-5 fw-bold">
                                        {ticket.ticketType}
                                      </span>
                                    </label>
                                    <label className="wo-label fw-semibold">
                                      Reported At: <span className="mb-0 fs-5 fw-bold">
                                        {ticket.reportedAt ? Moment.utc(ticket.reportedAt)
                                                                    .local()
                                                                    .format("YYYY-MM-DD HH:mm:ss") : ''}
                                      </span>
                                    </label>
                                    <div className="gap-2 mt-2">
                                    <label htmlFor="issueReported" className="wo-label mb-0">Issue Reported:</label>
                                    <ul className="mb-0">
                                      {ticket.issuesReported.map((issue: any, index: number) => (
                                        <li key={index} className="fs-5">{issue.name}</li>
                                      ))}
                                    </ul>
                                  </div>

                                  <div className="gap-2 mt-2">
                                    <label htmlFor="diagonsisDone" className="wo-label mb-0">Diagnosis Done:</label>
                                    <ul className="mb-0">
                                      {ticket.diagnosisDone.map((issue: any, index: number) => (
                                        <li key={index} className="fs-5">{issue.name}</li>
                                      ))}
                                      {
                                        ticket.diagnosisOtherInput && (
                                          <li className="fs-5">{ticket.diagnosisOtherInput}</li>
                                        )
                                      }
                                    </ul>
                                  </div>

                                  <div className="gap-2 mt-2">
                                    <label htmlFor="machineServicesDone" className="wo-label mb-0">Machine Service Done:</label>
                                    <ul className="mb-0">
                                      {ticket.machineServicesDone.map((issue: any, index: number) => (
                                        <li key={index} className="fs-5">{issue.name}</li>
                                      ))}
                                      {
                                        ticket.machineServiceOtherInput && (
                                          <li className="fs-5">{ticket.machineServiceOtherInput}</li>
                                        )
                                      }
                                    </ul>
                                  </div>
                                  

                                  
                                    </div>
                                    )
                                  })
                            )}
                          </div>
                        </div>
                      )
                    })
                  ) : null
                }
              </div>

              <div className="wo-form-section mt-8">
                <div className="border-dotted border-2 border-gray-200 p-8 gap-2 mb-8">

                  <h3 className="mb-0">Operation:</h3>
                  <ul className="list-unstyled ms-4 mt-4">
                    {logJob?.job?.operations?.map(
                      (operation: GetOperationType, index: number) => (
                        <li key={index}>
                          <label
                            className="form-check form-check-sm form-check-custom form-check-solid me-5 align-items-center d-flex  mt-1"
                          >
                            <input
                              id={`operation_${index}`}
                              className="form-check-input mb-2 me-1"
                              type="checkbox"
                              checked={true}
                              disabled={true}
                            />
                            <span className="ms-2 mb-1 fs-5 form-check-label" style={{ fontWeight: 'normal' }}>
                              {operation.name}
                            </span>
                          </label>
                        </li>
                      )
                    )}

                  </ul>
                </div>
              </div>

              <div className="wo-form-section mt-8">
                <div className="border-dotted border-2 border-gray-200 p-8 gap-2 mb-8">
                  <h3 className="mb-0">Marketing Materials:</h3>
                  <ul className="list-unstyled ms-4 mt-4">
                    {logJob?.job?.marketingMaterials?.map((material: GetMarketingType, index: number) => (
                      <li key={index}>
                        <label
                          className="form-check form-check-sm form-check-custom form-check-solid me-5 align-items-center d-flex mt-1"
                        >
                          <input
                            className="form-check-input mb-2 me-1"
                            type="checkbox"
                            checked={true}
                            disabled={true}
                          />
                          <span className="ms-2 mb-1 fs-5 form-check-label" style={{ fontWeight: 'normal' }}>
                            {material.name}
                          </span>
                        </label>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="wo-form-section mt-8">
                <div className="border-dotted border-2 border-gray-200 p-8 gap-2 mb-8">
                  <div className="align-items-center justify-content-between ">
                    <h3 className="mb-0">Flavor Price:</h3>
                    <table className="table table-bordered mt-4">
                      <thead>
                        <tr>
                          <th className="fw-bold mb-0">Flavor</th>
                          <th className="fw-bold mb-0">Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {logJob?.flavorPrices?.map((flavor: any) => {
                          const flavorKey = flavor.flavor; // Use 'name' as key
                          const currentFlavor = flavors?.find(
                            (item: any) => item.flavor === flavorKey
                          );

                          return (
                            <tr key={flavorKey}>
                              <td className="align-middle">{currentFlavor.name}</td>
                              <td className="align-middle">
                                <input
                                  type="number"
                                  name={`flavorPrices.${flavorKey}`}
                                  id={`flavorPrices_${flavorKey}`}
                                  className="form-control"
                                  value={flavor?.price ?? ""}
                                  disabled={true}
                                  readOnly={true}
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="mt-4">
                {[
                  { label: "Has a smoodi router?", name: "hasSmoodiRouter" },
                  { label: "Has Wifi extender?", name: "hasWifiExtender" },
                  {
                    label:
                      "Has pressure pump?",
                    name: "hasPressurePump",
                  },
                  {
                    label: "Has pressure tank?",
                    name: "hasPressureTank",
                  },
                ].map((item, idx) => (
                  <div
                    key={idx}
                    className="d-flex justify-content-between align-items-center mb-3"
                  >
                    <label className="wo-label">
                      {item.label}
                    </label>
                    <div className="form-check form-switch form-check-custom">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={logJob?.location?.[item.name]}
                        disabled={true}
                        name={item.name}
                      />
                    </div>
                  </div>
                ))}
              </div>

                <div className="mt-4 gap-2">
                  <label>Smoothie Setup</label>
                  {
                    logJob?.job?.attachments?.smoothieSetupMedia && logJob?.job?.attachments?.smoothieSetupMedia.length > 0 ? (

                      logJob.job.attachments.smoothieSetupMedia.map((media: any, index: number) => (
                        <div key={index}>
                          <img src={media.url} alt={`Smoothie setup media ${index + 1}`} className="img-fluid" />
                        </div>
                      ))
                    ) : (
                      <label>No smoothie setup media available</label>
                    )
                  }
                </div>

                <div className="mt-4 gap-2">
                  <label>Marketing Materials Present</label>
                  {
                    logJob?.job?.attachments?.marketingMaterialPresent && logJob?.job?.attachments?.marketingMaterialPresent.length > 0 ? (

                      logJob.job.attachments.marketingMaterialPresent.map((media: any, index: number) => (
                        <div key={index}>
                          <img src={media.url} alt={`Smoothie setup media ${index + 1}`} className="img-fluid" />
                        </div>
                      ))
                    ) : (
                      <div><label>No smoothie setup media available</label></div>
                    )
                  }
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
